import { ref } from "vue"

class ComponenteOpcaoUnicaService {
    setup({ opcoes, respostas }) {
        const opcaoUnica = ref('');
        const opcoesDisponiveis = ref(Object.keys(opcoes).map(key => ({
            valor: opcoes[key],
            id: key
        })));
    
        if (respostas) {
            opcaoUnica.value = opcoesDisponiveis.value.find(opcao => opcao.valor === respostas.resposta)?.valor || '';
        }
    
        return { opcaoUnica, opcoesDisponiveis };
    }
}

export default new ComponenteOpcaoUnicaService();